import React, { useRef, useEffect } from "react";
import { CheckOutlined } from "@ant-design/icons";

function Sort({ handleDropdownToggle, handleSort, handlePriceChange, range, currentSort = "featured" }) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        handleDropdownToggle();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleDropdownToggle]);

  const sortOptions = [
    { id: "featured", key: "featured", label: "Featured" },
    { id: "alphabeticalAZ", key: "alphabeticalAZ", label: "Alphabetical: A to Z" },
    { id: "alphabeticalZA", key: "alphabeticalZA", label: "Alphabetical: Z to A" },
    { id: "priceLowToHigh", key: "priceLowToHigh", label: "Price: Low to High" },
    { id: "priceHighToLow", key: "priceHighToLow", label: "Price: High to Low" },
  ];

  return (
    <div
      ref={dropdownRef}
      className="absolute top-12 right-0 md:right-auto md:left-48 z-30 bg-white border border-amber-200/90 rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.12)] p-4 min-w-[240px] animate-fadeIn"
    >
      <div className="text-xs uppercase font-bold text-gray-400 tracking-wider mb-2 px-1">
        Sort By
      </div>
      <div className="flex flex-col gap-1 mb-4">
        {sortOptions.map((option) => {
          const isSelected = currentSort === option.id || currentSort === option.key;
          return (
            <button
              key={option.key}
              type="button"
              className={`flex items-center justify-between text-left px-3 py-2 rounded-xl text-sm font-medium transition-all duration-150 cursor-pointer ${
                isSelected
                  ? "bg-[#FAF3E0] text-[#A17A17] font-semibold"
                  : "text-gray-700 hover:bg-amber-50/60 hover:text-[#A17A17]"
              }`}
              onClick={() => {
                handleSort(option);
                handleDropdownToggle();
              }}
            >
              <span>{option.label}</span>
              {isSelected && <CheckOutlined className="text-xs text-[#A17A17]" />}
            </button>
          );
        })}
      </div>

      <hr className="border-gray-100 my-2" />

      {/* Price Range Filter Slider */}
      <div className="pt-2">
        <div className="flex justify-between items-center mb-1 text-xs">
          <span className="font-bold text-gray-700">Max Price:</span>
          <span className="font-bold text-[#A17A17] bg-[#FAF3E0] px-2 py-0.5 rounded-md">
            {range > 0 ? `INR ${range}` : "All Prices"}
          </span>
        </div>
        <input
          type="range"
          id="priceRangeSlider"
          name="priceRangeSlider"
          min="0"
          max="2000"
          step="50"
          value={range}
          onChange={handlePriceChange}
          className="w-full accent-[#A17A17] cursor-pointer mt-1"
        />
        <div className="flex justify-between text-[11px] text-gray-400 mt-1">
          <span>₹0</span>
          <span>₹1000</span>
          <span>₹2000+</span>
        </div>
      </div>
    </div>
  );
}

export default Sort;